import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of, take } from 'rxjs';
import {
  Sc4FailedMessagesExportSetInitialState,
  Sc4FailedMessagesExportStart,
} from './sc4-failed-messages-export.actions';
import { Sc4FailedMessagesExportService } from './sc4-failed-messages-export.service';
import { catchError, map } from 'rxjs/operators';
import { NavigateUserService } from '../../../../../services/navigate-user.service';
import { NotificationService } from '../../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../../common/constants';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface Sc4FailedMessagesExportStateModel {
  loaded: boolean;
}

const initialState: Sc4FailedMessagesExportStateModel = {
  loaded: false,
};

@State({
  name: 'sc4FailedMessagesExport',
  defaults: initialState,
})
@Injectable()
export class Sc4FailedMessagesExportState {
  @Selector()
  static getState(state: Sc4FailedMessagesExportStateModel): Sc4FailedMessagesExportStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: Sc4FailedMessagesExportStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private waybillListExportService: Sc4FailedMessagesExportService,
    private notificationService: NotificationService,
    private navigateUserService: NavigateUserService,
  ) {}

  @Action(Sc4FailedMessagesExportStart)
  startExportToFile(
    ctx: StateContext<Sc4FailedMessagesExportStateModel>,
    { payload: { dialogRef, ...params } }: Sc4FailedMessagesExportStart,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.waybillListExportService.startExportToFile(params).pipe(
      take(1),
      map(() => {
        this.notificationService.success('api.export.success.exportStart');
        ctx.patchState({ loaded: true });
        dialogRef.close();
        if (params.navigationNeeded) {
          this.navigateUserService.navigateUserToAbsolutePath('/dashboard/exports');
        }
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc4FailedMessagesExportSetInitialState)
  setInitialState(ctx: StateContext<Sc4FailedMessagesExportStateModel>): void {
    ctx.setState(initialState);
  }
}
